import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'

const navigation = [
  { name: '首页', href: '/' },
  { name: '公司简介', href: '/about' },
  { name: '资质能力', href: '/qualifications' },
  { name: '检测平台', href: 'https://ecp.ldar100.cn' },
  { name: '信息公示', href: '/disclosure' },
  { name: '人才招聘', href: '/careers' },
  // { name: '环保要闻', href: '/news' },
  { name: '联系我们', href: '/contact' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  return (
    <header className="bg-gradient-to-r from-white via-primary-50/60 to-white shadow-sm border-b border-primary-100">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between py-4 md:py-6">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              className="h-12 w-auto"
              src="/images/logo-clean.png"
              alt="河南艾尔达环保科技有限公司"
            />
            <div className="ml-2 flex flex-col justify-between min-w-[360px]">
              <span className="text-xl font-extrabold tracking-[0.15em] text-primary-600 text-justify leading-tight">
                河南艾尔达环保科技有限公司
              </span>
              <span className="text-[12px] text-secondary-500 text-justify leading-tight mt-1">
                Henan Aierda Environmental Protection Technology Co.,Ltd
              </span>
            </div>
          </Link>

          <div className="hidden md:grid grid-cols-[auto_auto_auto] gap-x-5 text-primary-500 font-medium leading-tight tracking-[0.18em] justify-items-end">
            <span className="col-start-1 col-end-2 text-base font-bold">客观公正</span>
            <span className="col-start-2 col-end-3 text-base font-bold">科学规范</span>
            <span className="col-start-3 col-end-4 text-base" aria-hidden="true" />
            <span className="col-start-2 col-end-3 text-base mt-1 font-bold">诚实守信</span>
            <span className="col-start-3 col-end-4 text-base mt-1 font-bold">精益求精</span>
          </div>

          {/* Mobile menu button */}
          <div className="absolute right-0 md:hidden">
            <button
              type="button"
              className="text-secondary-600 hover:text-primary-600"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="sr-only">打开主菜单</span>
              {mobileMenuOpen ? (
                <X className="block h-6 w-6" />
              ) : (
                <Menu className="block h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex justify-center space-x-6 border-t border-secondary-200 pt-4 pb-2">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`px-3 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${
                location.pathname === item.href
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-secondary-600 hover:text-primary-600 hover:bg-secondary-50'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block px-3 py-2 rounded-md text-base font-semibold transition-colors duration-200 ${
                    location.pathname === item.href
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-secondary-600 hover:text-primary-600 hover:bg-secondary-50'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  )
} 